import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { transformDate, withNameSpace } from "app/common/LocalFunction";
import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import FormikFocusError from "app/common/form/FormikFocusError";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingStaff } from "app/services/StaffService";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import * as Yup from "yup";
import IconUserEdit from "app/common/Icon/IconUserEdit";
import history from "history.js";
import { PathModule } from "app/common/LocalConst";
import Config from "app/appConfig";
import { pagingCustomerSource } from "app/services/CustomerSourceService";

const CheckOutPopup = ({
  open,
  handleClose,
  handleSubmit,
  nameSpace = "",
  initialValues,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const validationSchema = Yup.object({
    checkoutTime: Yup.date()
      .transform(transformDate)
      .typeError("Thời gian check out không đúng định dạng!")
      .nullable()
      .required("Thời gian check out không được bỏ trống!")
      .test(
        "checkoutTime -maxDate",
        "Không được nhập quá thời gian hiện tại",
        function (value) {
          if (!value) return true;
          const now = new Date();
          return value <= now;
        }
      ),

    // department: Yup.object()
    //   .nullable()
    //   .required("Cơ sở check out không được bỏ trống!"),
  });
  console.log("initialValues", initialValues);

  return (
    <PopupForm
      open={open}
      size="sm"
      handleClose={handleClose}
      title={"Check out khách hàng"}
      formik={{
        initialValues: initialValues,
        onSubmit: handleSubmit,
        enableReinitialize: true,
        validationSchema: validationSchema,
      }}
      action={({ submitForm, setFieldValue, isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton
              disabled={isSubmitting}
              type="submit"
              className="btn-primary"
            >
              {!isMobile && <Save className="mr-2 " />}
              Check Out
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              {!isMobile && <Block className="mr-2" />}
              Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values, setSubmitting }) => {
        return (
          <>
            <FormikFocusError />
            <Grid container spacing={1} className="w-100 m-0">
              {/* <Grid item xs={12} sm={12}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("department", nameSpace)}
                  label={t("Cơ sở check out")}
                  api={pagingDepartment}
                  autoUpercase
                  required
                />
              </Grid> */}
              {/* <Grid item xs={12} sm={12}>
                <GlobitsPagingAutocomplete
                  name={withNameSpace("receptionist", nameSpace)}
                  label={t("Người check out")}
                  api={pagingStaff}
                  autoUpercase
                  displayLabel="staffName"
                />
              </Grid> */}
              <Grid item xs={12} sm={12}>
                <GlobitsDateTimePicker
                  label={t("Thời gian check out")}
                  name={withNameSpace("checkoutTime", nameSpace)}
                  isDateTimePicker
                  maxDate={new Date()}
                  maxDateMessage="Thời gian check out phải trước thời gian hiện tại"
                  required
                />
              </Grid>
            </Grid>
            <DialogCheckOut
              handleSubmit={handleSubmit}
              handleClose={handleClose}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const DialogCheckOut = observer(({ handleSubmit, handleClose }) => {
  const { values, setSubmitting } = useFormikContext();
  const { openConfirmCheckOut, setOpenConfirmCheckOut } =
    useStore().patientManagementStore.patientListStore;
  return (
    <>
      {openConfirmCheckOut && (
        <GlobitsConfirmationDialog
          title="Thông báo!"
          text={openConfirmCheckOut}
          onConfirmDialogClose={() => {
            setOpenConfirmCheckOut(null);
          }}
          // onYesClick={async () => {
          //   await handleSubmit(
          //     { ...values, skipCheckValiate: true },
          //     { setSubmitting }
          //   );
          //   setOpenConfirmCheckOut(null);
          // }}
          cancel="Hủy"
          // agree="Tiếp tục"
          open={!!openConfirmCheckOut}
        />
      )}
    </>
  );
});

export default memo(observer(CheckOutPopup));
